export const ConvertDayOfWeekToCalendarStartDay = (day) => {
    // the id for dayOfWeek in the database doesn't match the index value for the calendar so we need to convert it
    if(!day || day === 0){
        return 0;
    } else {
        return day - 1;
    }
}